import React from "react";
import Card from "@material-ui/core/Card";
import BaseCardStyles from "./baseCard.styles";
import SharpImage from "../utils/sharpImage";
import { useTheme } from "@material-ui/core/styles";

interface Props {
    image?: string;
    color: string;
    children: any;
    imageSize?: string;
    imageRight?: boolean;
    imageHeightAdjustment?: number;
    images: Array<any>;
}

export const BaseCard = ({ image, color, children, imageSize, imageRight, images, imageHeightAdjustment }: Props) => {
    const classes = BaseCardStyles();

    const theme = useTheme();

    if (imageSize !== "sml" && imageSize !== "md" && imageSize !== "lg")
        imageSize = "md"; //Default to md
    if (!imageHeightAdjustment)
        imageHeightAdjustment = 0;
    const imageHeight = 100 - imageHeightAdjustment;

    let asset = null;
    if (image && images)
        asset = images.filter(x => x.assetId === image)[0];

    const getBackground = () => {
        if (color === "darkest")
            return theme.palette.primary.darkest;
        else if (color === "dark")
            return theme.palette.primary.dark;
        else if (color === "main")
            return theme.palette.primary.main;
        else if (color === "light")
            return theme.palette.primary.light;
        else if (color === "lightest")
            return theme.palette.primary.lightest;
        else
            return theme.palette.background.paper
    }

    return (
        <Card className={classes.baseCardContainer} style={{ backgroundColor: getBackground(), color: theme.palette.getContrastText(getBackground()) }}>
            {!imageRight &&
                <div className={`${classes.baseCardImgContainer} ${imageSize === "sml" ? classes.baseCardImgContainerSml : ""}  ${imageSize === "md" ? classes.baseCardImgContainerMd : ""}  ${imageSize === "lg" ? classes.baseCardImgContainerLg : ""}`}>
                {asset && asset.localFile ?
                    <div style={{ top: "50%", transform: "translateY(-50%)", height: `${imageHeight}%`, position: "relative" }}><div className={classes.baseCardImg}><SharpImage file={asset.localFile} title={asset.fileName} altText={asset.fileName} /></div></div>
                        : <></>}
                </div>}
            <div className={`${classes.baseCardContentContainer} ${imageSize === "sml" ? classes.baseCardContentContainerImgSml : ""}  ${imageSize === "md" ? classes.baseCardContentContainerImgMd : ""}  ${imageSize === "lg" ? classes.baseCardContentContainerImgLg : ""}`}>
                {children}
            </div>
            {imageRight &&
                <div className={`${classes.baseCardImgContainer} ${imageSize === "sml" ? classes.baseCardImgContainerSml : ""}  ${imageSize === "md" ? classes.baseCardImgContainerMd : ""}  ${imageSize === "lg" ? classes.baseCardImgContainerLg : ""}`}>
                {asset && asset.localFile ?
                    <div style={{ top: "50%", transform: "translateY(-50%)", height: `${imageHeight}%`, position: "relative" }}><div className={classes.baseCardImg}><SharpImage file={asset.localFile} title={asset.fileName} altText={asset.fileName} /></div></div>
                        : <></>}
                </div>}
        </Card>
    );
}

BaseCard.NAME = "BaseCard";
export default BaseCard
